module.exports = __webpack_public_path__ + "media/Puzzle_Game_PowerUp_Light_04.93285452.wav";